import {
  getAttr,
  getEntityId,
} from '../../../../../features/helpers/apiHelpers';

export function mapInvitationGroup(invitationGroup) {
  return {
    title: getAttr(invitationGroup, 'name'),
    key: getEntityId(invitationGroup),
  };
}

export function mapInvitationGroupToSelectedItem(invitationGroup) {
  return getEntityId(invitationGroup);
}

export function mapInvitationGroupToDropdown(invitationGroup) {
  return {
    text: getAttr(invitationGroup, 'name'),
    key: getEntityId(invitationGroup),
  };
}
